import { versions } from 'constants/versions'
import { PAGAMO_RED } from 'constants/colors'

export const convertBaseUrlToSiteName = baseUrl =>
  baseUrl ? baseUrl.replace(/[/]/g, '') : 'global'

export const convertLanguageToVersion = language => {
  const lowerCaseLan = language.toLowerCase()
  if (lowerCaseLan.match('tw')) return versions.TW
  if (lowerCaseLan.match('en')) return versions.EN
  if (lowerCaseLan.match('cn')) return versions.CN
  return versions.EN // Default version
}

export const stripHtmlTags = html => html.replace(/<[^>]*>/g, '')

export const cutOffStr = limit => str => {
  if (str.length > limit) {
    return `${str.substring(0, limit)} ..`
  }
  return str
}

export const highLightKeyword = keyword => str =>
  str.replace(
    new RegExp(keyword, 'g'),
    `<b style="color: ${PAGAMO_RED}">${keyword}</b>`
  )
